import React, { useEffect, useState } from 'react';
import axios from 'axios';
import BillReceipt from './BillReceipt';
import BrandMark from '../../components/BrandMark';
import './publicReceipt.css';

// Public receipt pages deliberately run outside the signed-in POS providers.
export default function PublicReceipt() {
  const [state, setState] = useState({ loading: true, receipt: null, message: '' });
  useEffect(() => {
    const controller = new AbortController();
    const token = window.location.pathname.split('/')[2] || '';
    document.title = 'RestroDesk';
    if (!/^[A-Za-z0-9_-]{43}$/.test(token)) {
      setState({ loading: false, receipt: null, message: 'This bill link is invalid or no longer available.' });
      return () => controller.abort();
    }
    axios.get(`https://api.rcb.tdrsoftware.in/api/public-receipts/${encodeURIComponent(token)}`, {
      signal: controller.signal,
      withCredentials: false,
    }).then(({ data }) => {
      if (!controller.signal.aborted) setState({ loading: false, receipt: data.receipt, message: '' });
    }).catch(error => {
      if (controller.signal.aborted) return;
      const unavailable = [400, 404, 410].includes(error.response?.status);
      setState({ loading: false, receipt: null, message: unavailable
        ? 'This bill link is invalid or no longer available.'
        : 'Your bill could not be loaded right now. Please try opening the link again shortly.' });
    });
    return () => controller.abort();
  }, []);

  // Keep the two blocks stacked even if a stylesheet is slow to arrive.
  return <main className="public-receipt-page" style={{ display: 'block' }}>
    <header className="public-receipt-brand" aria-label="RestroDesk">
      <BrandMark className="public-receipt-brand-mark" width="32" height="32" />
      <div className="public-receipt-brand-text">
        <div className="public-receipt-brand-name">RestroDesk</div>
        <div className="public-receipt-brand-byline">by TDR Software</div>
      </div>
    </header>
    <div className="public-receipt-content">
      {state.loading ? <p role="status" className="public-receipt-message">Loading your bill…</p>
        : state.receipt ? <BillReceipt snapshot={state.receipt} showQr={false} />
          : <p role="alert" className="public-receipt-message">{state.message || 'This bill is unavailable.'}</p>}
    </div>
  </main>;
}
